import { lighten, readableColor } from 'polished';

// needs hex value for color (seems the thing we use most) and returns either white or black depending on what contrasts more
export const getContrastColor = (color: string): string => {
	if (!color || !color.match(/^#[0-9A-F]{6}$/i)) {
		return 'inherit';
	}
	return readableColor(color, '#ffffff', '#000000');
};

/**
 * Lightens a hex colour based on depth. Depth 0 returns the colour unchanged.
 * Each level lightens by 15%, capped at 40% total.
 */
export const lightenByDepth = (colour: string, depth: number): string => {
	if (depth === 0 || !colour || !colour.match(/^#[0-9A-Fa-f]{6}$/)) {
		return colour;
	}
	const amount = Math.min(depth * 0.15, 0.4);
	return lighten(amount, colour);
};
